"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEVEL_WARN = exports.LEVEL_INFO = exports.LEVEL_ERROR = exports.LEVEL_DEBUG = exports.LEVEL_CRITICAL = exports.default = void 0;

var _rollupPluginBabelHelpersE84dd01a = require("./_rollupPluginBabelHelpers-e84dd01a.js");

var _LEVEL_DEBUG$LEVEL_IN;

var LEVEL_DEBUG = 'debug';
exports.LEVEL_DEBUG = LEVEL_DEBUG;
var LEVEL_INFO = 'info';
exports.LEVEL_INFO = LEVEL_INFO;
var LEVEL_WARN = 'warn';
exports.LEVEL_WARN = LEVEL_WARN;
var LEVEL_ERROR = 'error';
exports.LEVEL_ERROR = LEVEL_ERROR;
var LEVEL_CRITICAL = 'critical';
exports.LEVEL_CRITICAL = LEVEL_CRITICAL;
var constants = (_LEVEL_DEBUG$LEVEL_IN = {}, (0, _rollupPluginBabelHelpersE84dd01a._)(_LEVEL_DEBUG$LEVEL_IN, LEVEL_DEBUG, 1), (0, _rollupPluginBabelHelpersE84dd01a._)(_LEVEL_DEBUG$LEVEL_IN, LEVEL_INFO, 2), (0, _rollupPluginBabelHelpersE84dd01a._)(_LEVEL_DEBUG$LEVEL_IN, LEVEL_WARN, 3), (0, _rollupPluginBabelHelpersE84dd01a._)(_LEVEL_DEBUG$LEVEL_IN, LEVEL_ERROR, 4), (0, _rollupPluginBabelHelpersE84dd01a._)(_LEVEL_DEBUG$LEVEL_IN, LEVEL_CRITICAL, 5), _LEVEL_DEBUG$LEVEL_IN);
var _default = constants;
exports.default = _default;